import { useMutation, useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import type { ICalculateWidget } from 'services/WidgetService/widget.service';
import { WidgetService } from 'services/WidgetService/widget.service';

export const WidgetCreateInvoice = () => {
  const { id } = useParams();

  const createInvoiceMutation = useMutation(
    'createInvoice',
    (data: ICalculateWidget) => WidgetService.createInvoice(data),
    {
      onSuccess: (data) => {
        globalThis.open(data?.data?.result?.redirect);
      },
    },
  );

  useQuery(['widgetInfo'], () => WidgetService.getWidgetInfo(id ?? ''), {
    onSuccess: (data) => {
      createInvoiceMutation.mutate({
        amount: data.data.result?.amount,
        payment_currency: data.data.result?.payment_currency,
        uuid: id ?? '',
      });
    },
    retry: false,
  });

  return <></>;
};
